/**
 * TanStack Query hooks for `platform-fee-monthly-manual-bank-transfer`. Thin wrappers over ./api.
 */
import {
	useMutation,
	useQuery,
	useQueryClient,
	type UseMutationResult,
	type UseQueryResult,
} from "@tanstack/react-query";
import {
	create,
	list,
	remove,
	platformFeeMonthlyManualBankTransferQueryKeys,
	type CreatePlatformFeeMonthlyManualBankTransferBody,
	type ListPlatformFeeMonthlyManualBankTransferResponse,
	type PlatformFeeMonthlyManualBankTransferRow,
} from "./api";

export function usePlatformFeeMonthlyManualBankTransferList(): UseQueryResult<ListPlatformFeeMonthlyManualBankTransferResponse, Error> {
	return useQuery({
		queryKey: platformFeeMonthlyManualBankTransferQueryKeys.list(),
		queryFn: list,
	});
}

export function usePlatformFeeMonthlyManualBankTransferCreate(): UseMutationResult<PlatformFeeMonthlyManualBankTransferRow, Error, CreatePlatformFeeMonthlyManualBankTransferBody> {
	const qc = useQueryClient();
	return useMutation({
		mutationFn: create,
		onSuccess: () => {
			qc.invalidateQueries({ queryKey: platformFeeMonthlyManualBankTransferQueryKeys.all });
		},
	});
}

export function usePlatformFeeMonthlyManualBankTransferDelete(): UseMutationResult<{ removed: boolean }, Error, string> {
	const qc = useQueryClient();
	return useMutation({
		mutationFn: remove,
		onSuccess: () => {
			qc.invalidateQueries({ queryKey: platformFeeMonthlyManualBankTransferQueryKeys.all });
		},
	});
}
